export default "__VITE_ASSET__CQxAiDn$__"